import React from 'react';

export default ({experience = {}}) => {
    const {
        totalEnrolleeCount: count,
        maxCapacity: max,
    } = experience;
    return (<>{count} / {max}</>)
};
